import { http } from '@/http/axios.js'
export function getImgCodeAPI(params) {
  return http({
    url: '/api/manage/basic/passport/misc/captcha',
    method: 'get',
    params
  })
}
